import { api } from '@/services/api'
import { API_ENDPOINTS } from '@myorg/type-lib'

import { NotificationDeviceApi ,NotificationResponse , TokenRegisterRequest } from "@myorg/type-lib"

const base = API_ENDPOINTS.MESSAGE.BASE
const SaveToken = API_ENDPOINTS.MESSAGE.MesPathSaveToken
const GetTokens = API_ENDPOINTS.MESSAGE.MesPathGetTokens
const DisableTokens = API_ENDPOINTS.MESSAGE.MesPathDisableTokens

export const notificationApiImpl: NotificationDeviceApi = {
  // Matches Go: /inside/api/message/save_token [post]
  saveToken: async (payload) => {
    const res = await api().post(base+SaveToken, payload)
    return res.data
  },

  // Matches Go: /inside/api/message/devices [get]
  getDevices: async (merchantId) => {
    const res = await api().get(base+GetTokens+`?merchant_id=${merchantId}`)
    return res.data
  },

  // Matches Go: /inside/api/message/clean_tokens [post]
  cleanTokens: async (tokens) => {
    const res = await api().post(base+DisableTokens, tokens)
    return res.data
  }
}